<template>
    <div id="generals" class="generals ping">
        <!-- 标题 -->
        <div class="generals-row">
            <div class="generals-header">
                <span v-if="isMobile" style="color:F8F2D8;">{{$t("role")}}</span>
            </div>
        </div>
        <!-- 武将图 -->
        <div class="generals-row">
            <div class="swiper-box">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="hero-info">
                                <img src="@assets/imgs/hero-bg.png" width="100%" />
                                <span class="hero-cv animated fadeInLeft">
                                    <img src="@assets/imgs/hero4_cv.png" />
                                </span>
                                <span class="hero-pic animated fadeInRight">
                                    <img src="@assets/imgs/hero4.png" />
                                </span>
                                <span class="hero-desc animated fadeInLeft">
                                    <img src="@assets/imgs/hero4_info.png" />
                                </span>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="hero-info">
                                <img src="@assets/imgs/hero-bg.png" width="100%" />
                                <span class="hero-cv animated fadeInLeft">
                                    <img src="@assets/imgs/hero2_cv.png" />
                                </span>
                                <span class="hero-pic animated fadeInRight">
                                    <img src="@assets/imgs/hero2.png" />
                                </span>
                                <span class="hero-desc animated fadeInLeft">
                                    <img src="@assets/imgs/hero2_info.png" />
                                </span>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="hero-info">
                                <img src="@assets/imgs/hero-bg.png" width="100%" />
                                <span class="hero-cv animated fadeInLeft">
                                    <img src="@assets/imgs/hero1_cv.png" />
                                </span>
                                <span class="hero-pic animated fadeInRight">
                                    <img src="@assets/imgs/hero1.png" />
                                </span>
                                <span class="hero-desc animated fadeInLeft">
                                    <img src="@assets/imgs/hero1_info.png" />
                                </span>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="hero-info">
                                <img src="@assets/imgs/hero-bg.png" width="100%" />
                                <span class="hero-cv animated fadeInLeft">
                                    <img src="@assets/imgs/hero3_cv.png" />
                                </span>
                                <span class="hero-pic animated fadeInRight">
                                    <img src="@assets/imgs/hero3.png" />
                                </span>
                                <span class="hero-desc animated fadeInLeft">
                                    <img src="@assets/imgs/hero3_info.png" />
                                </span>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="hero-info">
                                <img src="@assets/imgs/hero-bg.png" width="100%" />
                                <span class="hero-pic animated fadeInRight">
                                    <img src="@assets/imgs/hero5.png" />
                                </span>
                                <span class="hero-desc animated fadeInLeft">
                                    <img src="@assets/imgs/hero5_info.png" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 如果需要分页器 -->
                <div class="swiper-pagination page"></div>
                <!-- 如果需要导航按钮 -->
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";

export default {
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        cdnPrefix: {
            type: String,
            default: ""
        }
    },
    data() {
        return {};
    },
    components: {},
    mounted() {
        this._initSwiper();
    },
    methods: {
        // Swiper
        _initSwiper() {
            let mySwiper = new Swiper("#generals .swiper-container", {
                initalSlide: 2, //设定初始化时slide的索引，
                // direction: "vertical",//slide的滑动方向
                speed: 500, //滑动速度，开始滑动到结束滑动的时间
                autoplay: 500, //可选选项，自动滑动,值为自动滑动的间隔
                autoplayDisableOnInteraction: false, //操作后是否停止自动滑动
                autoplayStopOnLast: false, //设置为true，切换到最后一个slide时停止自动切换
                grabCursor: true, //拖动时指针会变成抓手形状
                loop: false, // 循环
                // 分页器 - 即小圆点
                pagination: {
                    el: "#generals .swiper-pagination",
                    clickable: true, //可点击切换
                    type: "bullets" //bullets 圆点（默认） fraction 分式 progressbar 进度条 custom 自定义
                },
                // 左右的切换按钮
                navigation: {
                    nextEl: "#generals .swiper-button-next",
                    prevEl: "#generals .swiper-button-prev"
                },
                // 鼠标滚轮控制切换
                mousewheel: true,
                // 切换效果 slide fade cube coverflow flip
                effect: "fade",
                centeredSlides: true,
                slidesPerView: "auto",
                coverflowEffect: {
                    rotate: 50,
                    stretch: 10,
                    depth: 100,
                    modifier: 1,
                    slideShadows: false
                }
            });
        }
    }
};
</script>

<style lang="scss">
.generals {
    height: 100%;
    min-height: 800px;
    padding: 70px 0 0;
    .generals-row {
        width: 100%;
        display: flex;
        justify-content: center;
        .generals-header {
            background: url("~@assets/imgs/wujiang-text-cn.png") center
                center no-repeat;
            background-size: 100% auto;
            width: 350px;
            height: 100px;
            margin: 100px auto 0;
            img {
                width: 100%;
            }
        }
        .swiper-box {
            position: relative;
            width: 1100px;
            margin: 0 auto;
            padding: 0 100px;
            .swiper-container {
                width: 100%;
                .swiper-wrapper {
                    .swiper-slide {
                        width: 900px;
                        .hero-info {
                            position: relative;
                            padding-top: 23%;
                            span {
                                display: none;
                                position: absolute;
                                z-index: 10;
                            }
                            .hero-cv {
                                width: 17%;
                                left: 10%;
                                bottom: 10%;
                                z-index: 20;
                                img {
                                    width: 100%;
                                }
                            }
                            .hero-pic {
                                width: 60%;
                                left: 6%;
                                bottom: 5%;
                                img {
                                    width: 100%;
                                }
                            }
                            .hero-desc {
                                width: 30%;
                                right: 8%;
                                bottom: 10%;
                                z-index: 20;
                                img {
                                    width: 100%;
                                }
                            }
                        }
                    }
                    .swiper-slide-active {
                        .hero-info {
                            span {
                                display: block;
                            }
                        }
                    }
                }
            }
            // 分页按钮
            .swiper-pagination {
                width: 900px;
                height: 50px;
                line-height: 50px;
                .swiper-pagination-bullet {
                    width: 12px;
                    height: 12px;
                    margin: 0 5px;
                    background: #fff;
                    opacity: 0.8;
                    transition: all 0.1s linear;
                    outline: none;
                }
                .swiper-pagination-bullet-active {
                    background: #f00;
                }
            }
            // 翻页按钮
            .swiper-button-prev,
            .swiper-button-next {
                width: 50px;
                height: 50px;
                outline: none;
                border-radius: 50%;
            }
            .swiper-button-prev {
                background: url("~@assets/imgs/btn_prev.png") center center
                    no-repeat;
                background-size: 50% 60%;
                background-color: rgba(0, 0, 0, 0.3);
                left: 35px;
            }
            .swiper-button-next {
                background: url("~@assets/imgs/btn_next.png") center center
                    no-repeat;
                background-size: 50% 60%;
                background-color: rgba(0, 0, 0, 0.3);
                right: 35px;
            }
        }
    }
}
@media screen and (max-width: 1440px) {
    .generals {
        .generals-row {
            .swiper-box {
                width: 900px;
                padding: 0 100px;
                .swiper-container {
                    .swiper-wrapper {
                        .swiper-slide {
                            width: 700px;
                        }
                    }
                }
                // 分页按钮
                .swiper-pagination {
                    width: 700px;
                    height: 30px;
                    line-height: 30px;
                }
                .swiper-button-prev {
                    left: 20px;
                }
                .swiper-button-next {
                    right: 20px;
                }
            }
        }
    }
}
// 移动端
@media screen and (max-width: 768px) {
    .generals {
        height: auto;
        min-height: 400px;
        padding: 0;
        background: url("~@assets/imgs/bgphone-p20n.png") center center
            no-repeat;
        background-size: 100% auto;
        .generals-row {
            .generals-header {
                width: 250px;
                height: 60px;
                margin: 20px auto 0;
            }
            .swiper-box {
                width: 600px;
                padding: 0;
                // 分页按钮
                .swiper-pagination {
                    width: 100%;
                }
                // 翻页按钮
                .swiper-button-prev,
                .swiper-button-next {
                    width: 30px;
                    height: 30px;
                    outline: none;
                    top: 100%;
                    border-radius: 50%;
                    background-color: rgba(0, 0, 0, 0.3);
                    margin-top: 0;
                }
                .swiper-button-prev {
                    left: 10%;
                }
                .swiper-button-next {
                    right: 10%;
                }
            }
        }
    }
}
@media screen and (max-width: 500px) {
    .generals {
        .generals-row {
            .generals-header {
                width: 100%;
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                font-weight: bold;
                color: #f8f2d8;
                background: url("~@assets/imgs/bgphone-title.png") center
                    center no-repeat;
                background-size: 330px 35px;
                text-align: center;
            }
            .swiper-box {
                width: 100%;
                padding: 0 5%;
                margin-top: -10px;
                .swiper-container {
                    width: 100%;
                    .swiper-wrapper {
                        width: 100%;
                        .swiper-slide {
                            width: 95%;
                            text-align: center;
                        }
                    }
                }
                // 分页按钮
                .swiper-pagination {
                    width: 90%;
                }
            }
        }
    }
}
@media screen and (max-width: 375px) {
    .generals {
        min-height: 300px;
    }
}
@media screen and (max-width: 360px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Generals.vue